// extracted by mini-css-extract-plugin
export default {"container":"wz-z","dimension":"xz-z","dimensionLabels":"yz-z"};